import styled from "styled-components";

export const StyledTie = styled.div`
    svg {
        path {
            fill: ${p => p.theme.c.score};
        }
    }
`;
